document.addEventListener('DOMContentLoaded', () => {
  const category = document.getElementById('defect-categories-show');
  if (!category || typeof document.createElement('dialog').showModal !== 'function') return;

  category.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-defect-media]');
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    const dialog = document.createElement('dialog');
    dialog.className = 'defect-media-dialog';
    dialog.setAttribute('aria-labelledby', 'defect-media-title');

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'btn defect-media-close';
    close.textContent = 'Close';
    close.addEventListener('click', () => dialog.close());

    const title = document.createElement('h2');
    title.id = 'defect-media-title';
    title.textContent = link.dataset.mediaTitle;

    const isVideo = link.dataset.defectMedia === 'video';
    const media = document.createElement(isVideo ? 'iframe' : 'img');
    media.src = link.href;
    if (isVideo) {
      media.title = link.dataset.mediaTitle;
      media.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      media.allowFullscreen = true;
    } else {
      media.alt = link.dataset.mediaAlt;
    }

    dialog.appendChild(close);
    dialog.appendChild(title);
    dialog.appendChild(media);
    dialog.addEventListener('close', () => {
      dialog.remove();
      link.focus();
    });
    document.body.appendChild(dialog);
    dialog.showModal();
  });
});
